import { render, staticRenderFns } from "./ProfileTable.vue?vue&type=template&id=824147fe&"
import script from "./ProfileTable.vue?vue&type=script&lang=js&"
export * from "./ProfileTable.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports